module.exports = __webpack_public_path__ + "img/edit-password.bfafbddd.svg";